// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__30-RH","item":"styles_item__3XH9H"};